import { render } from "./MainTitle.vue?vue&type=template&id=2f9393b0&scoped=true"
const script = {}

import "./MainTitle.vue?vue&type=style&index=0&id=2f9393b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9393b0"]])

export default __exports__